




import { Vue, Component } from 'vue-property-decorator';

import YourAccountEmail from './default-user-signup/YourAccount.vue';
import { OnboardingURL } from '@/views/Onboarding/helpers';

@Component({
  components: { YourAccountEmail }
})
export default class DirectYourAccountEmail extends Vue {
  get backUrl() {
    return OnboardingURL.YOUR_BUSINESS_PREVIEW;
  }

  get nextUrl() {
    return OnboardingURL.USER_SIGN_UP_COMPLETE;
  }
}
